import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const StdQty: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Std Qty',
  minWidth: 40,
  accessorFn: (product) => `${product.standard_qty}`,
  gloss: 'How many units make up one pack — for example, a single can vs. a 6-pack of beer.',
});
